import { sansSerifStyles } from "@pathwright/blocks/src/ui/typography"
import styled from "styled-components"
import { isMobile } from "../../utils"

export const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`

const AttachmentsBase = styled.div`
  width: 80%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 1rem 0;
`

export const AttachmentsEditWrapper = styled(AttachmentsBase)`
  .Attachments__add-attachment > span {
    display: flex;
    align-items: center;
  }
`

export const AttachmentsViewWrapper = styled(AttachmentsBase)`
  ${(p) =>
    p.empty
      ? `
    padding: 0;
  `
      : ``}
`

export const AttachmentsListWrapper = styled(Row)`
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: auto;

  .AttachmentListItem,
  .Attachment,
  .Attachment__content {
    width: 100%;
  }
`

export const AttachmentListItemWrapper = styled.div`
  height: ${(p) => (p.isMobile ? "auto" : "80px")};
  min-height: ${(p) => (p.isMobile ? "80px" : "")};
  display: flex;
  margin-bottom: 5px;
  cursor: pointer;

  .ql-editor > p {
    border-bottom: 1px solid rgba(0, 0, 0, 0);
    line-height: 1;
    display: inline-block;
  }

  /* Ignore Block styles */
  .ql-editor,
  .ql-editor > *,
  .BlockText,
  .BlockText > * {
    color: #292e35 !important;
  }

  &:hover .ql-editor > p {
    border-bottom: 1px dashed rgba(0, 0, 0, 0.4);
  }

  ${isMobile()
    ? `.ql-editor > p {
      border-bottom: 1px dashed rgba(0, 0, 0, 0.4);
    };`
    : ""}

  .ql-toolbar,
  .ql-tooltip {
    display: none;
  }

  .BlockText {
    line-height: 1;
  }

  .BlockText,
  .BlockText p,
  .ContentText {
    margin: 0;
    ${sansSerifStyles()}
  }

  .Attachment {
    height: 100%;
    margin-right: 0;
  }

  a.Attachment:hover .Pathicon {
    color: #999999 !important;
  }

  .Attachment__content {
    justify-content: space-between;
    padding: 0;

    & > span {
      display: flex;
      align-items: center;
    }

    .Attachment__thumbnail {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .Attachment__thumbnail-icon {
      font-size: 2rem;
    }

    .Attachment__thumbnail-img {
      max-height: 3rem;
      height: 3rem;
      width: 3rem;
      object-fit: cover;
    }

    .Attachment__actions {
      .Pathicon {
        font-size: 18px;
      }
    }

    /* Placeholder */
    .Attachment__content-meta .ql-editor:before {
      position: static;
    }
  }
`

export const AttachmentsAddWrapper = styled.div`
  width: 100%;
`
